const offerData = [
	{
		title: 'Prowadzenie ksiąg rachunkowych',
		content: [
			'JPK – sporządzanie i wysyłanie Jednolitych Plików Kontrolnych.',
			'Oopracowanie zakładowego planu kont.',
			'Bieżące ewidencjonowanie operacji gospodarczych.',
			'Sporządzanie deklaracji i rozliczeń w zakresie podatku dochodowego oraz podatku od towarów i usług.',
			'Prowadzenie ewidencji środków trwałych, wraz z miesięcznym naliczaniem amortyzacji.',
			'Sporządzanie bilansów, rachunków wyników.',
			'Okresowe opracowanie sprawozdań dla GUS i NBP.',
		],
		icon: require('../assets/offer-ico_5.png'),
	},
	{
		title: 'Prowadzenie ksiąg przychodów i rozchodów',
		content: [
			'Bieżące ewidencjonowanie operacji gospodarczych.',
			'Sporządzanie deklaracji i rozliczeń w zakresie podatku dochodowego oraz podatku od towarów i usług.',
			'Prowadzenie ewidencji środków trwałych, wraz z miesięcznym naliczaniem amortyzacji oraz ewidencji wyposażenia.',
			'Prowadzenie ewidencji przebiegu pojazdów wraz z miesięcznym rozliczaniem.',
			'Sporządzanie rozliczeń rocznych.',
		],
		icon: require('../assets/offer-ico_6.png'),
	},
	{
		title: 'Prowadzenie ewidencji przychodów',
		content: [
			'JPK – sporządzanie i wysyłanie Jednolitych Plików Kontrolnych.',
			'Miesięczne naliczanie podatku.',
			'Sporządzanie deklaracji i rozliczeń dla potrzeb podatku.',
			'Prowadzenie wykazu środków trwałych.',
			'Sporządzanie rozliczeń rocznych',
		],
		icon: require('../assets/offer-ico_1.png'),
	},
	{
		title: 'Obsługa kadrowa',
		content: [
			'Sporządzanie dokumentów dotyczących nawiązywania i rozwiązywania stosunku pracy.',
			'Prowadzenie akt osobowych pracownika.',
			'Prowadzenie całości spraw związanych z kalendarzami pracowników (urlopy wypoczynkowe, chorobowe, urlopy macierzyńskie, ewidencja urlopów i inne).',
			'Sporządzanie i wydawanie pracownikom niezbędnej dokumentacji, dotyczącej przebiegu zatrudnienia.',
			'Prowadzenie i aktualizacja rejestru badań lekarskich i szkoleń BHP.',
			'Kompletowanie dokumentacji pracowników w celu ustalenia kapitału początkowego.',
			'Sporządzanie regulaminów wewnętrznych pracodawcy (regulamin pracy, regulamin wynagradzania, regulamin zakładowego funduszu świadczeń socjalnych,).',
			'Obsługę zatrudnienia osób w ramach umów cywilnoprawnych (umowy zlecenia, umowy o dzieło).',
			'Obsługa kontroli Państwowej Inspekcji Pracy i ZUS.',
		],
		icon: require('../assets/offer-ico_3.png'),
	},
	{
		title: 'Dofinansowania i rozpoczęcie działalności',
		content: [
			'Pomoc przy wypełnianiu wniosków o dofinansowanie z Urzędu Pracy, Środków Unijnych itp..',
			'Pomoc w tworzeniu biznesplanów.',
			'Kompleksowe doradztwo z zakresu ekonomiczno-finansowego oraz podatkowego podczas procesu tworzenia przedsiębiorstwa.',
		],
		icon: require('../assets/offer-ico_2.png'),
	},
]

export { offerData }
